import React from "react";
import { Link } from "react-router-dom";

export default function SuccessPage() {
  return (
    <div
      className="d-flex justify-content-center align-items-center vh-100"
      style={{
        background: "linear-gradient(135deg, #9eb89fff, #8a8a8aff)",
        color: "#fff",
      }}
    >
      <div
        className="card text-center shadow-lg"
        style={{
          background: "#fff",
          color: "#333",
          borderRadius: "20px",
          padding: "40px 30px",
          maxWidth: "420px",
          width: "90%",
        }}
      >
        <div className="mb-3">
          <img
            src="https://cdn-icons-png.flaticon.com/512/845/845646.png"
            alt="Success"
            style={{ width: "90px", height: "90px" }}
          />
        </div>

        <h3 className="fw-bold">Payment Successful!</h3>
        <p className="text-muted mt-2 mb-4">
          Your transaction has been completed successfully.
        </p>

        <div
          className="border rounded p-3 mb-3 d-none"
          style={{ background: "#f9f9f9" }}
        >
          <p className="m-0 fw-semibold">Transaction ID:</p>
          <p className="m-0 text-primary">#TXN123456789</p>
          <p className="m-0 mt-2 fw-semibold">Amount:</p>
          <p className="m-0 text-success">₹1,000.00</p>
        </div>

        {/* <Link
          to="/dashboard"
          className="btn btn-success w-100 fw-semibold"
          style={{ borderRadius: "30px", padding: "10px 0" }}
        >
          Go to Dashboard
        </Link> */}
      </div>
    </div>
  );
}
